let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kLzWL")).then(() => parcelRequire('53QVn'));